import { render, staticRenderFns } from "./QuadInfo.vue?vue&type=template&id=b45b4020&scoped=true&"
import script from "./QuadInfo.vue?vue&type=script&lang=js&"
export * from "./QuadInfo.vue?vue&type=script&lang=js&"
import style0 from "./QuadInfo.vue?vue&type=style&index=0&id=b45b4020&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45b4020",
  null
  
)

export default component.exports